const {
    Dialog,
    DialogTitle,
    DialogContent,
    CircularProgress,
    IconButton,
} = require("@mui/material");
import PrimaryButton from "../PrimaryButton";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React, { useState, useEffect } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import Wallets from "./wallets";
import { TRANSACTION_TYPE } from "../../utils/constants";
import { useSelector } from "react-redux";
import useDidMountEffect from "../../utils/useDidMountEffect";
import loadScript from "load-script";
import GpayInfo from "./gpayInfo";
import CoverAvatar from "./coverAvatar";

const stripePromise = loadStripe(process.env.MIX_STRIPE_KEY);

let paymentsClient = null;

loadScript("https://pay.google.com/gp/p/js/pay.js", function (err, script) {
    if (err) {
        console.error("Google Pay SDK failed to load.", err);
    } else {
        console.log("Google Pay SDK loaded");
        paymentsClient = new google.payments.api.PaymentsClient({
            environment:
                process.env.APP_ENV === "production" ? "PRODUCTION" : "TEST",
        });
    }
});

const PaymentOptions = ({
    show = false,
    setShow,
    onClickPayNow,
    action = null,
    pu,
    item = null,
    onSuccess,
    isBusy = false,
    price = null,
    isPromo = false,
}) => {
    const [clientSecret, setClientSecret] = useState(null);
    const [busy, setBusy] = useState(false);
    const [currency, setCurrency] = useState("usd");
    const [amount, setAmount] = useState(0);
    const [preparing, setPreparing] = useState(true);
    const [canPay, setCanPay] = useState(false);
    const [isSuccessful, setIsSuccessful] = useState(false);
    const [isGpayAvailable, setIsGpayAvailable] = useState(false);
    const [checkGpayBusy, setCheckGpayBusy] = useState(false);
    const [payWithGpay, setPayWithGpay] = useState(false);

    const darkmode = useSelector((state) => state.privaGlobal.darkmode);

    const handleClose = () => setShow(false);

    const loadElements = async () => {
        await stripePromise;
    };

    const fetchClientSecret = async () => {
        setBusy(true);
        let puId = null;

        if (action === TRANSACTION_TYPE.PPV) {
            puId = localStorage.getItem("other_user");
        } else {
            puId = pu.id;
        }

        let payload = {
            transaction_type: action,
            user_id: puId,
            payment_method: "wallet",
        };

        if (action === TRANSACTION_TYPE.POST_PPV) {
            if (item && Object.keys(item).length > 0) {
                payload.post_id = item.id;
            }
        }

        if (action === TRANSACTION_TYPE.PPV) {
            payload.msg_id = item.id;
        }

        if (action === TRANSACTION_TYPE.TIP) {
            payload.user = puId;
            payload.amount = price;

            if (item && Object.keys(item).length > 0) {
                payload.post_id = item.id;
            }
        }

        await axios
            .post("/api/v1/payments/checkout", payload)
            .then((response) => {
                setBusy(false);
                if (
                    response.data.data &&
                    Object.keys(response.data.data).length > 0
                ) {
                    setClientSecret(response.data.data.client_secret);
                    setCurrency(response.data.data.currency);
                    setAmount(response.data.data.amount);
                } else {
                    setPreparing(false);
                }
            })
            .catch((error) => {
                console.error(error);
                setBusy(false);
            });
    };

    const handleGpay = () => {
        setPayWithGpay(true);
    };

    useEffect(() => {
        if (payWithGpay) {
            fetchClientSecret();
        }

        return () => {};
    }, [payWithGpay]);

    useEffect(() => {
        if (show) {
            loadElements();
            isReadyToPay();
        }

        return () => {
            setCanPay(false);
            setIsGpayAvailable(false);
            setIsSuccessful(false);
            setPayWithGpay(false);
            setPreparing(true);
        };
    }, [show]);

    useEffect(() => {
        return () => {
            setCanPay(false);
            setIsGpayAvailable(false);
            setIsSuccessful(false);
            setPayWithGpay(false);
            setPreparing(true);
        };
    }, []);

    const options = {
        clientSecret,
    };

    const handlePayNow = () => {
        setShow(false);
        onClickPayNow();
    };

    const handleSuccess = () => {
        setIsSuccessful(true);
    };

    useDidMountEffect(() => {
        if (isSuccessful && action !== TRANSACTION_TYPE.TIP) {
            setTimeout(() => {
                onSuccess();
                setShow(false);
            }, 3000);
        } else {
            onSuccess();
        }
    }, [isSuccessful]);

    const RenderOrDivider = () => {
        return (
            <div
                css={css`
                    text-align: center;
                    border-bottom: 1px solid #ccc;
                    line-height: 0;
                    margin: 25px 0;
                `}
            >
                <span
                    css={css`
                        padding: 0 10px;
                        background-color: ${darkmode ? "#121212" : "#fff"};
                        font-size: 18px;
                        color: ${darkmode ? "#fcfcfc" : "rgba(0, 0, 0, 0.87)"};
                        background-image: ${darkmode
                            ? "linear-gradient(rgba(255, 255, 255, 0.16),rgba(255, 255, 255, 0.16))"
                            : "none"};
                    `}
                >
                    or
                </span>
            </div>
        );
    };

    const isReadyToPay = () => {
        console.log("🚀 ~ isReadyToPay ~ isReadyToPay:");

        const isReadyToPayRequest = {
            apiVersion: 2,
            apiVersionMinor: 0,
            allowedPaymentMethods: [
                {
                    type: "CARD",
                    parameters: {
                        allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
                        allowedCardNetworks: ["VISA", "MASTERCARD"],
                    },
                },
            ],
        };

        console.log("🚀 ~ isReadyToPay ~ paymentsClient:", paymentsClient);

        setCheckGpayBusy(true);
        paymentsClient
            .isReadyToPay(isReadyToPayRequest)
            .then(function (response) {
                if (response.result) {
                    // GPay available
                    setIsGpayAvailable(true);

                    console.log("🚀 ~ isReadyToPay:true");
                } else {
                    // GPay not available
                    setIsGpayAvailable(false);
                    console.log("🚀 ~ isReadyToPay:false");
                }

                setCheckGpayBusy(false);
            })
            .catch(function (error) {
                setCheckGpayBusy(false);
                setIsGpayAvailable(false);
                console.log("🚀 ~ isReadyToPay: false");
                console.error("GPay readiness error:", error);
            });
    };

    return (
        <Dialog
            onClose={handleClose}
            open={show}
            sx={{
                "& .MuiPaper-root": {
                    borderRadius: "8px",
                    margin: 0,
                },
            }}
            PaperProps={{
                sx: {
                    width: {
                        xs: "calc(100% - 15px)", // for mobile screens
                    },
                    margin: 0,
                },
            }}
        >
            {isSuccessful ? (
                <DialogTitle
                    sx={{
                        textAlign: "center",
                    }}
                >
                    Thank you. Your payment has been accepted, please wait a
                    moment to complete.
                </DialogTitle>
            ) : null}

            {(!canPay || !isGpayAvailable) && !preparing && !busy && !isBusy ? (
                <DialogTitle
                    sx={{
                        textAlign: "center",
                    }}
                >
                    We couldn't detect Google Pay.
                </DialogTitle>
            ) : null}

            <DialogContent sx={{ padding: "20px 3px", overflowX: "hidden" }}>
                {action === TRANSACTION_TYPE.SUBSCRIPTION && !payWithGpay ? (
                    <CoverAvatar user={pu} price={price} isPromo={isPromo} />
                ) : null}

                {!isSuccessful ? (
                    <div
                        css={css`
                            text-align: center;
                        `}
                    >
                        <h2
                            css={css`
                                font-weight: 500;
                                font-size: 1.25rem;
                                margin: 0;
                                font-family: "Segoe UI", "Segoe UI Emoji",
                                    "Segoe UI Symbol", -apple-system;
                                line-height: 1.6;
                                padding: 0 24px 16px 24px;
                            `}
                        >
                            {payWithGpay && canPay
                                ? "Tap to pay with your Google Pay card."
                                : ""}

                            {!payWithGpay ? "How would you like to pay?" : ""}
                        </h2>
                    </div>
                ) : null}

                {busy || isBusy || isSuccessful || checkGpayBusy ? (
                    <div
                        css={css`
                            display: flex;
                            justify-content: center;
                        `}
                    >
                        <CircularProgress size={28} />
                    </div>
                ) : null}

                {(!canPay || !isGpayAvailable) &&
                !preparing &&
                !busy &&
                !isBusy ? (
                    <GpayInfo />
                ) : null}

                {isGpayAvailable && !checkGpayBusy && !payWithGpay ? (
                    <div>
                        <PrimaryButton
                            type="button"
                            sx={{
                                width: "100%",
                                padding: "2px 10px",
                                background: "#000",
                                textTransform: "none",
                                fontSize: "16px",
                                fontWeight: "400",
                                "&:hover": {
                                    backgroundColor: "#000",
                                    opacity: 0.8,
                                },
                            }}
                            size="medium"
                            onClick={handleGpay}
                        >
                            <img
                                src="/images/gpay.svg"
                                css={css`
                                    margin-right: 12px;
                                    width: 80px;
                                `}
                                width="80"
                            />{" "}
                            {action === TRANSACTION_TYPE.SUBSCRIPTION
                                ? "Subscribe"
                                : "Pay"}{" "}
                            with Google Pay
                        </PrimaryButton>
                    </div>
                ) : null}

                {clientSecret &&
                !busy &&
                !isBusy &&
                isGpayAvailable &&
                payWithGpay ? (
                    <React.Fragment>
                        <Elements stripe={stripePromise} options={options}>
                            <div
                                id="express-checkout"
                                css={css`
                                    position: relative;
                                    min-height: ${!canPay ? "unset" : "40px"};
                                `}
                            >
                                {canPay ? (
                                    <div
                                        css={css`
                                            width: 100%;
                                            text-align: center;
                                            font-weight: 400;
                                            position: absolute;
                                            top: 0;
                                            font-size: 16px;
                                            padding: 8px;
                                        `}
                                    >
                                        Loading Google Pay
                                    </div>
                                ) : null}

                                <Wallets
                                    clientSecret={clientSecret}
                                    amount={amount}
                                    currency={currency}
                                    onSuccess={handleSuccess}
                                    setShow={setShow}
                                    preparing={preparing}
                                    setPreparing={setPreparing}
                                    canPay={canPay}
                                    setCanPay={setCanPay}
                                />
                            </div>
                        </Elements>

                        {canPay && action === TRANSACTION_TYPE.SUBSCRIPTION ? (
                            <div
                                css={css`
                                    font-size: 14px;
                                `}
                            >
                                <strong>
                                    You're subscribing to {pu.login}
                                </strong>{" "}
                                <br />
                                USD ${price}/month with Google Pay
                            </div>
                        ) : null}
                    </React.Fragment>
                ) : null}

                {!busy &&
                !isBusy &&
                ((!payWithGpay && !isSuccessful) ||
                    (payWithGpay && !preparing && !canPay)) ? (
                    <div
                        css={css`
                            margin-top: 15px;
                        `}
                    >
                        <PrimaryButton
                            fullWidth={true}
                            onClick={handlePayNow}
                            disabled={isBusy}
                            sx={{
                                textTransform: "none",
                                padding: "12px 10px",
                                fontWeight: "400",
                                fontSize: "16px",
                            }}
                        >
                            Use Card Payment Method
                        </PrimaryButton>
                    </div>
                ) : null}
            </DialogContent>
        </Dialog>
    );
};

export default PaymentOptions;
